import BaseApi from "./BaseApi";

export default class CentralCosts extends BaseApi {
    construct() {}

    static async search(params = {}) {
        return await CentralCosts.getAxiosInstance().get(CentralCosts.getApiUrl() + "/search", {
            params,
        });
    }

    static async users(id) {
        return await CentralCosts.getAxiosInstance().get(
            CentralCosts.getApiUrl() + "/" + id + "/users"
        );
    }

    static async syncUsers(id, params = {}) {
        return await CentralCosts.getAxiosInstance().put(
            CentralCosts.getApiUrl() + "/" + id + "/users",
            params
        );
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "central-costs";
    }
}